import React, { Component } from "react";
import axios from "../../../axios";
import moment from "moment";
import FormDropdown from "../../../components/FormDropdown";
import DatePicker from "react-datepicker";
import qs from "qs";
import queryString from "query-string";
import Alert from "react-s-alert";
import Paging from "../../../components/Paging";
import fp from "lodash/fp";
import { Badge, Nav } from "reactstrap";
import NavLink from "react-router-dom/NavLink";
import XLSX from "xlsx";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

class Lists extends Component {
  constructor() {
    super();
    this.state = {
      dataKelas: [],
      dataMapel: [],
      dataGuru: [],
      dataReport: [],
      pageCount: 0,
      currentPage: 0,
      user_id: "",
      mapel_id: "",
      dateNowStart: "",
      dateNowEnd: "",
      dateStart: moment(),
      dateEnd: moment(),
      isLoading: true,
      isButtonLoading: false,
      isModalShow: false,
      exam_id: "",
      sortName: "",
      sortOrder: "",
      startNo: 1,
    };

    this.handleChangeDatepickerStart = this.handleChangeDatepickerStart.bind(
      this
    );
    this.handleChangeDatepickerEnd = this.handleChangeDatepickerEnd.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleChangeDatepickerStart(e) {
    this.setState(
      {
        dateStart: e,
        dateNowStart: e.format("YYYY-MM-DD"),
        isLoading: true,
      },
      () => {
        this.loadData();
      }
    );
  }

  handleChangeDatepickerEnd(e) {
    this.setState(
      {
        dateEnd: e,
        dateNowEnd: e.add(1, "days").format("YYYY-MM-DD"),
        isLoading: true,
      },
      () => {
        this.loadData();
      }
    );
  }

  toggleModal(e) {
    this.setState({
      modalShow: !this.state.modalShow,
      exam_id: e,
    });
  }

  handlePageClick(data) {
    let selected = data.selected; // zero based index

    this.setState({ currentPage: selected }, () => {
      this.loadData();
    });
  }

  loadDataMapel() {
    axios
      .post("/mapel")
      .then((response) => {
        return response.data.mapelexport.map((item) => ({
          key: item.mapel_id,
          value: item.mapel_nama,
        }));
      })
      .then((result) => {
        this.setState({
          dataMapel: result,
        });
      })
      .catch((error) => {
        console.log("Mapel Undefinded");
      });
  }

  loadDataGuru() {
    axios
      .post("/user?level=guru")
      .then((response) => {
        return response.data.data.map((item) => ({
          key: item.user_id,
          value: item.user_nama,
        }));
      })
      .then((result) => {
        this.setState({
          dataGuru: result,
        });
      })
      .catch((error) => {
        console.log("Guru Undefinded");
      });
  }

  handleChangeStatus(exam_status, exam_id, user_id) {
    if (exam_status == 1) {
      exam_status = 0;
    } else {
      exam_status = 1;
    }
    let exam_status_new = exam_status;
    console.log("data status " + exam_status);
    axios
      .post(
        "/exam/update-status",
        qs.stringify({ exam_status_new, exam_id: exam_id, user_id: user_id })
      )
      .then((response) => {
        this.loadData();
      })
      .catch((error) => {
        console.log(error);
        Alert.error("Gagal terhubung ke server!");
      });
  }

  loadData() {
    this.setState({ isLoading: true, isButtonLoading: true });

    const params = qs.stringify({
      page: this.state.currentPage + 1,
      mapel: this.state.mapel_id,
      user: this.state.user_id,
      tglMulai: this.state.dateNowStart,
      tglEnd: this.state.dateNowEnd,
      sortName: this.state.sortName,
      sortOrder: this.state.sortOrder,
    });

    axios
      .post("/ujian?" + params)

      .then((response) => {
        const result = response.data;

        if (result.success === true) {
          this.setState({
            dataReport: result.data.data,
            pageCount: result.data.last_page,
            isLoading: false,
            isButtonLoading: false,
            startNo: result.data.from,
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
          });
        } else {
          Alert.error(result.message, {
            position: "bottom-right",
          });
          this.setState({ isLoading: false });
        }
      })

      .catch((error) => {
        this.setState({ isLoading: false });
        Alert.error("Gagal terhubung ke server!", {
          position: "bottom-right",
        });
      });
  }

  componentDidMount() {
    if (localStorage.SISMART_USER_LEVEL !== "administrator") {
      this.props.history.replace("/dashboard");
    }
    this.loadDataMapel();
    this.loadDataGuru();
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.mapel_id !== this.state.mapel_id ||
      prevState.user_id !== this.state.user_id ||
      prevState.sortName !== this.state.sortName ||
      prevState.sortOrder !== this.state.sortOrder
    ) {
      this.loadData();
    }
  }

  onSortChange(sortName, sortOrder) {
    this.setState({
      sortName,
      sortOrder,
    });
  }

  render() {
    const strt = this.state.startNo;
    const url = this.props.match.url;

    function indexN(cell, row, enumObject, index) {
      return <div>{index + strt}</div>;
    }

    function formatCat(cell, row, enumObject, index) {
      return row.exam_cat_type != null ? row.exam_cat_type.toUpperCase() : "-";
    }

    function formatDate(cell, row, enumObject, index) {
      return moment(row.exam_end_date).format("DD MMMM YYYY - h:m:s A");
    }

    function formatNama(cell, row, enumObject, index) {
      return (
        <div>
          {row.exam_title}
          <div style={{ marginTop: "10px" }}>
            <Badge color={"primary"} style={{ padding: "5px" }}>
              {row.user_nama}
            </Badge>
            <br />
            <Badge color={"primary"} style={{ padding: "5px" }}>
              {row.mapel_nama}
            </Badge>
          </div>
        </div>
      );
    }

    function formatStatus(cell, row, enumObject, index) {
      return (
        <button
          type="button"
          className={`btn ${
            row.exam_status === "1" ? "btn-primary" : "btn-danger"
          }`}
          title={
            row.exam_status === "1"
              ? "Non Aktifkan Ujian Ini"
              : "Aktifkan Ujian Ini"
          }
          onClick={() => {}}
        >
          {row.exam_status === "1" ? "Aktif" : "Non Aktif"}
        </button>
      );
    }

    function formatOpsi(cell, row, enumObject, index) {
      return (
        <NavLink
          to={`${url}/detail/${row.exam_id}`}
          className="btn btn-secondary btn-sm"
        >
          Siswa
        </NavLink>
      );
    }

    const options = {
      clearSearch: true,
      searchPosition: "left",
      sortName: this.state.sortName,
      sortOrder: this.state.sortOrder,
      onSortChange: this.onSortChange.bind(this),
    };

    return (
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">Pantau Ujian dan Tugas</div>
          <div className="card-block">
            <div className="form-group row">
              <div className="col-md-2">
                <FormDropdown
                  items={this.state.dataGuru}
                  onChange={this.handleChange}
                  value={this.state.user_id.toString()}
                  placeholder={"Pilih Guru"}
                  name="user_id"
                />
              </div>

              <div className="col-md-2">
                <FormDropdown
                  items={this.state.dataMapel}
                  onChange={this.handleChange}
                  value={this.state.mapel_id.toString()}
                  placeholder={"Pilih Mapel"}
                  name="mapel_id"
                />
              </div>

              <div className="col-md-2">
                {
                  <DatePicker
                    selected={this.state.dateStart}
                    onChange={this.handleChangeDatepickerStart}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={15}
                  />
                }
              </div>

              <div className="col-md-2">
                {
                  <DatePicker
                    selected={this.state.dateEnd}
                    onChange={this.handleChangeDatepickerEnd}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={15}
                  />
                }
              </div>
            </div>
            <hr />
            {this.state.isLoading ? (
              "Memuat Data..."
            ) : this.state.dataReport.length === 0 ? (
              "Data tidak ditemukan..."
            ) : (
              <div>
                <BootstrapTable
                  data={this.state.dataReport}
                  striped
                  hover
                  remote
                  options={options}
                >
                  <TableHeaderColumn
                    width="50"
                    dataField="any"
                    dataFormat={indexN}
                    isKey
                  >
                    No
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="100"
                    dataField="exam_cat_type"
                    dataSort
                    dataFormat={formatCat}
                  >
                    Type
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="250"
                    dataField="exam_title"
                    dataSort
                    dataFormat={formatNama}
                  >
                    Nama Ujian/Tugas
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="200"
                    dataField="exam_end_date"
                    dataSort
                    dataFormat={formatDate}
                  >
                    Max. Time
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="100"
                    dataField="exam_cat_status"
                    dataFormat={formatStatus}
                  >
                    Status
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="100"
                    dataField="any"
                    dataFormat={formatOpsi}
                  >
                    Opsi
                  </TableHeaderColumn>
                </BootstrapTable>
                <hr />
                <Paging
                  handlePageClick={this.handlePageClick}
                  pageCount={this.state.pageCount}
                  currentPage={this.state.currentPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Exam/Pantau/Lists.js